module.exports = __webpack_public_path__ + "img/btn.cd3ed9fb.png";